import { getDependencyTree } from "mobx";
export function printDebugValue(v) {
    return getDependencyTree(v);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/mobx-react-lite/es/printDebugValue.js
// module id = 861
// module chunks = 0